import { render, staticRenderFns } from "./DisableStorageModal.vue?vue&type=template&id=4618d134&scoped=true&"
import script from "./DisableStorageModal.vue?vue&type=script&lang=js&"
export * from "./DisableStorageModal.vue?vue&type=script&lang=js&"
import style0 from "./DisableStorageModal.vue?vue&type=style&index=0&id=4618d134&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4618d134",
  null
  
)

export default component.exports